import type { KpiMetrics, OrderKpiMetrics } from '@klareospace/pharos-lib-types';
import { isDriverTaskKpiRows, ORDER_KPI_METRIC_KEYS } from '@klareospace/pharos-lib-types';

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Narrows a `Kpi.metrics` (absent while computing, or the `driver-task-kpis` row array) to `OrderKpiMetrics`. */
export function isOrderKpiMetrics(
  metrics: KpiMetrics | undefined,
): metrics is OrderKpiMetrics & Record<string, number> {
  if (!metrics || isDriverTaskKpiRows(metrics)) return false;
  return ORDER_KPI_METRIC_KEYS.every((key) => typeof metrics[key] === 'number');
}

/** Returns `metrics` narrowed to `OrderKpiMetrics`, or `undefined` when it isn't (still computing). */
export function toOrderKpiMetrics(metrics: KpiMetrics | undefined): OrderKpiMetrics | undefined {
  return isOrderKpiMetrics(metrics) ? metrics : undefined;
}
